import { createI18n } from 'vue-i18n'
import { getBrowserLocale } from '@/helpers/languageHelpers'
import LocalStorageConst from "@/constants/LocalStorageConst"
import fr from './langs/fr.json'
import nl from './langs/nl.json'

// Type-define 'fr' as the master schema for the resource
type MessageSchema = typeof fr

const getStartingLocale = () : string => {
    let lang = localStorage.getItem(LocalStorageConst.LOCALE)
    if (lang) {
        return lang
    }
    if ('languages' in navigator) {
        lang = getBrowserLocale() 
    }
    
    return (!lang || !['fr', 'en', 'nl'].includes(lang) ? process.env.VUE_APP_I18N_LOCALE || "fr" : lang)
}

const i18n = createI18n<[MessageSchema], 'fr' | 'nl'>({
    allowComposition: true,
    legacy: false,
    locale: getStartingLocale(),
    fallbackLocale: 'fr',
    datetimeFormats: {
        'fr': {
            short: {
                day: 'numeric', month: 'short', year: 'numeric'
            },
            shortFullMonth: {
                day: 'numeric', month: 'long', year: 'numeric'
            },
            shortNumeric: {
                day: 'numeric', month: 'numeric', year: 'numeric'
            },
            shortNoYear: {
                month: 'short', day: 'numeric'
            },
            long: {
                day: 'numeric', month: 'short', year: 'numeric',
                weekday: 'short', hour: 'numeric', minute: 'numeric'
            },
            longNumeric: {
                day: 'numeric', month: 'numeric', year: 'numeric',
                hour: 'numeric', minute: 'numeric'
            }
        },
        'nl': {
            short: {
                year: 'numeric', month: 'short', day: 'numeric'
            },
            shortFullMonth: {
                year: 'numeric', month: 'long', day: 'numeric'
            },
            shortNumeric: {
                year: 'numeric', month: 'numeric', day: 'numeric'
            },
            long: {
                year: 'numeric', month: 'short', day: 'numeric',
                weekday: 'short', hour: 'numeric', minute: 'numeric'
            },
            longNumeric: {
                year: 'numeric', month: 'numeric', day: 'numeric',
                hour: 'numeric', minute: 'numeric'
            },
            shortNoYear: {
                month: 'short', day: 'numeric'
            }
        },
    },
    messages: {
        'fr': fr,
        'nl': nl,
    }
})

export default i18n